import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "@/components/layout/HomePageLayout";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

const Terms = () => {
  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-0">
        <h1 className="text-2xl font-bold mb-4">Terms of Service</h1>
        <div className="prose max-w-none [&_p]:text-base [&_p]:leading-7 [&_p]:my-0 [&_p]:mb-4 [&_h2]:leading-tight [&_h2]:mb-4 [&_h2]:mt-8 [&_h3]:leading-tight [&_h3]:mb-3 [&_h3]:mt-6 [&_ul]:my-0 [&_ul]:mb-4 [&_ol]:my-0 [&_ol]:mb-4 [&_li]:text-base [&_li]:leading-7 [&_li]:m-0 [&_li]:pl-1 [&_li>p]:m-0">
          <p className="text-base text-muted-foreground mb-8">
            Last updated: June 2025
          </p>

          <Separator className="my-8" />

          <div className="space-y-6">
            <h2 className="text-2xl font-semibold mt-8">
              Verified Profile Criteria
            </h2>
            <p>
              To ensure trust, quality, and reliability across the World Class Design platform, the "Verified" badge is granted only to users who meet the following criteria:
            </p>

            <h2 className="text-2xl font-semibold mt-8">
              Profile Completion Requirements
            </h2>
            <p>
              To be eligible for verification, a user's profile must be considered 100% complete. This includes the following:
            </p>
            <ol className="list-decimal pl-6 space-y-4">
              <li>
                <span className="font-bold">About Me Section</span><br />
                A written summary that clearly introduces who you are, your professional background, and your current design focus.
              </li>
              <li>
                <span className="font-bold">Work Experience</span><br />
                At least one work experience entry that outlines your professional design history. This should include the role, company, and a brief description of responsibilities or achievements.
              </li>
              <li>
                <span className="font-bold">Project Portfolio</span><br />
                A minimum of three (3) project entries that demonstrate the quality of your design work. Each project must include:
                <ul className="list-disc pl-6 space-y-2 mt-2">
                  <li>A project title</li>
                  <li>A description of your contribution</li>
                  <li>Visual evidence of the work (e.g., images, prototypes, or links)</li>
                </ul>
              </li>
            </ol>

            <h2 className="text-2xl font-semibold mt-8">
              Review and Approval Process
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                All verified profiles are subject to manual review by the World Class Design team.
              </li>
              <li>
                Submitting false, misleading, or plagiarized information will result in disqualification from verification and may lead to removal from the platform.
              </li>
              <li>
                Users may be contacted for additional information or clarification during the review process.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-8">
              Ongoing Eligibility
            </h2>
            <p>
              Verification status is not permanent. World Class Design reserves the right to revoke verification at any time, including but not limited to the following cases:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>If a profile becomes inactive or incomplete</li>
              <li>If concerns arise regarding the authenticity of the content</li>
              <li>If the quality of work no longer aligns with the evolving standards of what we consider world-class</li>
            </ul>
            <p>
              As our benchmarks are continuously refined, some profiles may lose verification if they do not reflect the level of excellence expected on the platform.
            </p>
            <p>
              Users may update their profiles and re-apply for verification at any time.
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Terms; 